import { lenis } from '../../resources/js/modules/animations';

// Safari (incl. 17.x) often needs explicit play() after metadata; <source>-only markup can fail to paint.
document.querySelectorAll('.js-parallax-hero-video video').forEach((video) => {
  video.muted = true;
  video.defaultMuted = true;
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');

  const tryPlay = () => {
    const p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(() => {});
    }
  };

  if (video.readyState >= 2) {
    tryPlay();
  } else {
    video.addEventListener('loadeddata', tryPlay, { once: true });
    video.addEventListener('canplay', tryPlay, { once: true });
  }
});

document.querySelectorAll('.js-hero-anchor').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    e.preventDefault();

    const currentSection = anchor.closest('section');
    if (!currentSection) return;

    const nextSection = currentSection.nextElementSibling;
    if (!nextSection) return;

    lenis.scrollTo(nextSection, { offset: 0, duration: 1.1 });
  });
});
